import React, { useState } from "react";
import styled from "styled-components";
import { InputText, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import { authorizedRequest } from "utils/api";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 440px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Template = styled.div`
  padding: 16px;
`;

const campaignMap = {
  "Refi Cash Out": "We think you should refi this deal name",
  "Refi Breakeven": "You would have been better off if you refi deal name today",
  "Prepayment": "We think you should prepay this deal name"
};

export const TemplateCreator = ({ campaign, dealName }) => {
  const [inputValue, setInputValue] = useState("");

  const sendEmail = async () => {
    const body = {
      recipient: inputValue,
      htmlBody: `
        <div>
          <p>
            Hello,
          </p>
          <p>
            ${campaignMap[campaign].replace("deal name", dealName)}
          </p>
          <p>
            <a href="https://www.loanboss.com/ " target="_blank">Click here to find out more!</a>
          </p>
          <p>
            <span>From,</span> <br /> <span>Broker</span>
          </p>
        </div>
      `
    };
    try {
      const response = await authorizedRequest("/send-email", "POST", body, null, false);
      if (response && response.success === true) {
        ToastSuccess("Email sent successfully!");
      } else {
        ToastError(response.Message || "Something went wrong, please try again");
      }
    } catch (e) {
      ToastError("Something went wrong, please try again");
    }
  };

  return (
    <Wrapper>
      <InputText
        variant="outlined"
        placeholder="Send To"
        label={"Send To"}
        name="recipient"
        type="text"
        onChange={e => setInputValue(e.target.value)}
        value={inputValue}
        style={{ width: "320px", marginTop: "16px" }}
      />
      <Template>
        <p>
          Hello,
        </p>
        <p>
          {campaignMap[campaign].replace("deal name", dealName)}
        </p>
        <p>
          <a href="https://www.loanboss.com/ " target="_blank" rel="noreferrer">Click here to find out more!</a>
        </p>
        <p>
          <span>From,</span>
          {" "}
          <br />
          {" "}
          <span>Broker</span>
        </p>
      </Template>
      <Footer>
        <SecondaryButton
          label="Send"
          size={ButtonSizeOptions.smFluid}
          onClick={sendEmail}
        />
      </Footer>
    </Wrapper>
  );
};

export default TemplateCreator;
